module.exports = __webpack_public_path__ + "h5/img/money.75f0c289.png";